import api from './index'
import { axios } from '@/utils/request'
import qs from 'qs'

export function getLabelList (params) {
  return axios({
    url: api.LabelList,
    method: 'get',
    params: params
  })
}

export function createLabel (params) {
  return axios({
    url: api.CreateLabel,
    method: 'post',
    params: params
  })
}

export function updateLabel (params) {
  return axios({
    url: api.UpdateLabel + '/' + params.label_id,
    method: 'post',
    params: {
      label_name: params.label_name,
      parent_label_id: params.parent_label_id
    }
  })
}

export function deleteLabel (label_id) {
  return axios({
    url: api.DeleteLabel + '/' + label_id,
    method: 'post'
  })
}
